/** The three inbox reply tabs. */
export enum ReplyTab {
	MY = "MY",
	TEAM = "TEAM",
	ALL = "ALL",
}

export interface SenderSelectionItem {
	id: number | string | null;
	title?: string;
}

/**
 * Resolves the sender ids the inbox list query should filter by, given the
 * active reply tab and the (tab-scoped) senders dropdown narrowing.
 *
 * - MY: always the current user.
 * - TEAM: the narrowed selection, or every teammate when nothing is narrowed.
 * - ALL: the narrowed selection, or empty (no filter = all replies).
 *
 * The "all" sentinel used by the dropdown is stripped out; an empty result means
 * "no sender filter".
 */
export const resolveEffectiveSenders = (
	replyTab: ReplyTab,
	selectedSenders: SenderSelectionItem[],
	teamMemberIds: number[],
	userId?: number
): number[] => {
	if (replyTab === ReplyTab.MY) {
		return userId ? [userId] : [];
	}

	const explicit = selectedSenders
		.filter((sender) => sender.id !== "all")
		.map((sender) => sender.id)
		.filter((id): id is number => typeof id === "number");

	if (replyTab === ReplyTab.TEAM) {
		return explicit.length ? explicit : teamMemberIds;
	}

	return explicit;
};
